module.exports = __webpack_public_path__ + "static/media/az.fa9c079d.svg";